export default {"src":"/_next/static/media/support_team_icon.bf5ab27d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};